import styled from "styled-components";
import DefaultThumbnail from "../DefaultThumbnail";
import { useEffect, useRef, useState } from "react";
import Spinner from "components/atoms/loader/Spinner";
import * as s from "./ThumbnailStyled";
import { encodeImagePath } from "utils/functions";
import ThumbnailError from "./ThumbnailError";
import { CVV_ERROR_STATUS } from "api/interfaces/reportInterface.interface";
import NoPermissionThumbnail from "./NoPermission";

type VideoThumbnailProps = {
  isRecorderList?: boolean;
  videoLoss: boolean;
  thumbnailUrl: string | undefined;
  errorType?: string;
  isLazy?: boolean;
  installationStatus?: string;
  isRefreshing?: boolean;
  /** 뷰포트 밖(인쇄 전용 페이지 등)에서는 IntersectionObserver가 안 돌아가므로 즉시 렌더 */
  skipIntersection?: boolean;
  isNoPermission?: boolean;
};

function VideoThumbnail(props: VideoThumbnailProps): JSX.Element {
  // console.log(props.thumbnailUrl, "VideoThumbnail");
  const [isThumbnailError, setIsThumbnailError] = useState<boolean>(false);
  const imgContainerRef = useRef<HTMLDivElement>(null);
  const [startRender, setStartRender] = useState<boolean>(false);
  const imageLoadingMode =
    props.isLazy === false || props.skipIntersection ? "eager" : "lazy";

  const imageOnErrorHandler = (
    event: React.SyntheticEvent<HTMLImageElement, Event>
  ) => {
    event.currentTarget.style.display = "none";
    if (!props.videoLoss) {
      setIsThumbnailError(true);
    }
  };

  useEffect(() => {
    if (!startRender) return;
    setIsThumbnailError(false);
  }, [props.thumbnailUrl, startRender]);
  useEffect(() => {
    if (props.skipIntersection) {
      setStartRender(true);
      return;
    }
    //window스크롤시 해당 컴포넌트가 노출될때 이미지 렌더링
    const container = imgContainerRef.current;
    if (container) {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setStartRender(true);
        }
      });
      observer.observe(container);
      return () => observer.disconnect();
    }
  }, [props.thumbnailUrl, props.skipIntersection]);

  if (
    props.installationStatus !== undefined &&
    props.installationStatus === "WAITING"
  ) {
    return (
      <>
        <SpinnerContainer>
          <Spinner size={25} aria-label="Loading Spinner" />
        </SpinnerContainer>
        <DefaultThumbnail></DefaultThumbnail>
      </>
    );
  }
  if (props.isNoPermission) {
    return (
      <DefaultThumbnail>
        <NoPermissionThumbnail />
      </DefaultThumbnail>
    );
  }
  return (
    <DefaultThumbnail ref={imgContainerRef}>
      {startRender &&
        (props.errorType !== undefined &&
        props.errorType.toLowerCase() !== "success" ? (
          <ThumbnailError
            isRecorderList={props.isRecorderList}
            errorStatus={props.errorType}
          />
        ) : props.thumbnailUrl === undefined ||
          props.thumbnailUrl === "" ||
          props.thumbnailUrl.includes("ThumbnailNotFound.png") ? (
          props.videoLoss ? (
            <ThumbnailError
              isRecorderList={props.isRecorderList}
              errorStatus={CVV_ERROR_STATUS.VIDEO_LOSS}
            />
          ) : props.installationStatus !== undefined ? (
            <ThumbnailError
              isRecorderList={props.isRecorderList}
              errorStatus={props.installationStatus}
            />
          ) : (
            <ThumbnailError
              isRecorderList={props.isRecorderList}
              errorStatus={"thumbnailnotavailable"}
            />
          )
        ) : (
          <s.ImageBg>
            {props.videoLoss && (
              <ThumbnailError
                isRecorderList={props.isRecorderList}
                errorStatus={CVV_ERROR_STATUS.VIDEO_LOSS}
                transparent={!isThumbnailError}
              />
            )}
            <div className="black-filter"></div>
            {isThumbnailError && (
              <ThumbnailError
                isRecorderList={props.isRecorderList}
                errorStatus="ThumbnailNotAvailable"
              />
            )}
            {!isThumbnailError && props.thumbnailUrl && (
              <img
                src={encodeImagePath(props.thumbnailUrl)}
                alt="recorder-thumbnail"
                onError={imageOnErrorHandler}
                loading={imageLoadingMode}
                className="thumbnail-url"
              />
            )}
          </s.ImageBg>
        ))}
    </DefaultThumbnail>
  );
}

export const SpinnerContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 12;
`;

export default VideoThumbnail;
